<template>
  <div class="content_human">
    <div class="content_model" v-if="show"><i class="el-icon-loading"></i></div>
    <div class="content_body">
      <iframe src="https://artist.kingfisher.live/cloud/designer/index.html#/presenter/136237106f0c53b7"
        style="width: 100%;height: 100%;"></iframe>
      <div class="box1">
        <div class="box_header">能耗</div>
        <div class="box_body" ref="box1"></div>
      </div>
      <div class="box2">
        <div class="box_header">近两月能耗对比</div>
        <div class="box_body" ref="box2"></div>
      </div>
      <div class="box3">
        <div class="box_header">电流</div>
        <div class="box_body" ref="box3"></div>
      </div>
      <div class="box4">
        <div class="box_header">总功率</div>
        <div class="box_body" ref="box4"></div>
      </div>
      <div class="box5">
        <div class="box_header">空气质量</div>
        <div class="box_body" ref="box5"></div>
      </div>
      <div class="box6">
        <div class="box_header">室外温湿度</div>
        <div class="box_body" ref="box6"></div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts';
import service from '../../service/leftService.js'
import { max } from 'moment';
export default {
  name: '',
  props: [''],
  data() {
    return {
      vidsrc: require('../../assets/diy/01.mp4'),
      show: true,
      testSize: 0,
      testArray: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
      yData: [],
      y1Data: [],
      y2Data: [],
      y3Data: [],
      house: '',
      minutes: '',
      second: "",
      temp: '0.00',
      humd: '0.00',
      co2: '0.00',
      voc: '0.00',
      timmer: null,
      box3: {
        ydata: [],
        xdata1: [],
        xdata2: [],
        xdata3: [],
        xdata4: [],
      }
    };
  },

  components: {},

  computed: {},

  beforeMount() { },

  mounted() {
    this.getEcherData()
    this.$nextTick(function () {
      this.echartsPoint();
      this.doEcharts()
    });
    setTimeout(() => {
      this.show = false;
    }, 5000)
    this.timmer = setInterval(() => {
      this.getData()
    }, 1000)
  },

  methods: {
    echartsPoint() {
      let box2 = echarts.init(this.$refs.box2);
      box2.setOption(
        {
          backgroundColor: '',
          legend: {
            top: "20",
            x: "center",
            textStyle: {
              color: "rgba(101, 213, 255, 1)"
            },
            icon:
              "path://M512 881.777778 512 881.777778C716.222629 881.777778 881.777778 716.222629 881.777778 512 881.777778 307.777371 716.222629 142.222222 512 142.222222 307.777373 142.222222 142.222222 307.777371 142.222222 512 142.222222 716.222629 307.777373 881.777778 512 881.777778L512 881.777778ZM512 1024 512 1024C229.230208 1024 0 794.769789 0 512 0 229.230211 229.230208 0 512 0 794.769789 0 1024 229.230211 1024 512 1024 794.769789 794.769789 1024 512 1024L512 1024Z",
            itemWidth: 8, // 设置宽度
            itemHeight: 8, // 设置高度、
            itemGap: 12 // 设置间距
          },
          tooltip: {
            show: true,
            trigger: "axis", //axis , item
            backgroundColor: "#ffffff",
            borderColor: "#ffffff",
            borderWidth: 1,
            borderRadius: 0,
            textStyle: {
              color: "#ffffff",
              align: "left"
            }
          },
          grid: {
            right: "5%",
            top: "20%",
            left: "5%",
            bottom: "5%",
            containLabel: true
          },
          xAxis: {
            type: "category",
            boundaryGap: true,
            data: ["1F", "2F", '3F', '4F', '5F', '6F', '7F', '8F'],
            axisLabel: {
              //坐标轴刻度标签的相关设置。
              interval: 0, //设置为 1，表示『隔一个标签显示一个标签』
              //	margin:15,
              textStyle: {
                color: "#FFFFFF",
                fontStyle: "normal",
              }
            },
            axisTick: {
              //坐标轴刻度相关设置。
              show: false
            },
            axisLine: {
              //坐标轴轴线相关设置
              lineStyle: {
                color: "rgba(77, 128, 254, 0.2)"
              }
            },
            splitLine: {
              //坐标轴在 grid 区域中的分隔线。
              show: false,
              lineStyle: {
                color: "rgba(77, 128, 254, 0.2)"
              }
            }
          },
          yAxis: [
            {
              type: "value",
              splitNumber: 3,
              axisLabel: {
                textStyle: {
                  color: "#ffffff",
                  fontStyle: "normal",
                }
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: "rgba(77, 128, 254, 0.2)"
                }
              }
            }
          ],
          series: [
            {
              name: '2月',
              type: "pictorialBar",
              barWidth: "60%",
              stack: "总量",
              label: {
                normal: {
                  show: false
                }
              },
              itemStyle: {
                normal: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#51D5DD" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#51D5DD" // 100% 处的颜色
                      }
                    ],
                    globalCoord: false // 缺省为 false
                  } //渐变颜色
                }
              },
              symbol:
                "path://M12.000,-0.000 C12.000,-0.000 16.074,60.121 22.731,60.121 C26.173,60.121 -3.234,60.121 0.511,60.121 C7.072,60.121 12.000,-0.000 12.000,-0.000 Z",

              data: [23, 84, 101, 74, 87, 105, 95, 86]
            }, {
              name: '3月',
              type: "pictorialBar",
              barWidth: "60%",
              stack: "总量",
              label: {
                normal: {
                  show: false
                }
              },
              itemStyle: {
                normal: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#1580CF" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#1580CF" // 100% 处的颜色
                      }
                    ],
                    globalCoord: false // 缺省为 false
                  } //渐变颜色
                }
              },
              symbol:
                "path://M12.000,-0.000 C12.000,-0.000 16.074,60.121 22.731,60.121 C26.173,60.121 -3.234,60.121 0.511,60.121 C7.072,60.121 12.000,-0.000 12.000,-0.000 Z",
              data: [13, 54, 71, 24, 57, 65, 35, 54]
            }],
        }
      )
      window.addEventListener('resize', () => {
        box2.resize()
      })
      let datas = {
        value: 60,
        name: '完成率',
      };
      let box3 = echarts.init(this.$refs.box3);
      box3.setOption(
        {

          tooltip: {
            trigger: 'axis'
          },
          legend: {
            textStyle: {
              color: '#1bb4f6'
            },
            x: 'center',
            y: '20',
            data: ['A向电流', 'B向电流', 'C向电流']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            axisLabel: {
              color: '#65D5FF'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#65D5FF'
              }
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#65D5FF'
              }
            },
            data: this.box3.ydata
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              formatter: '{value}',
              textStyle: {
                color: '#65D5FF'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#65D5FF'
              }
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#54d1ff33'
              }
            }
          },
          series: [
            {
              name: 'A向电流',
              type: 'line',
              symbol: 'none',
              itemStyle: {
                normal: {
                  color: '#339FAF',
                  lineStyle: {
                    color: "#339FAF",
                    width: 1
                  },
                }
              },
              data: this.box3.xdata2
            },
            {
              name: 'B向电流',
              type: 'line',
              symbol: 'none',
              itemStyle: {
                normal: {
                  color: '#5CB2EC',
                  lineStyle: {
                    color: "#5CB2EC",
                    width: 1
                  },
                }
              },
              data: this.box3.xdata1
            },
            {
              name: 'C向电流',
              type: 'line',
              symbol: 'none',
              itemStyle: {
                normal: {
                  color: '#FFEB93',
                  lineStyle: {
                    color: "#FFEB93",
                    width: 1
                  },
                }
              },
              data: this.box3.xdata3
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        box3.resize()
      })
      let box4 = echarts.init(this.$refs.box4);
      box4.setOption(
        {
          title: {
            text: datas.value + '%',
            x: '49%',
            y: '45%',
            textAlign: 'center',
            textStyle: {
              fontWeight: 'bold',
              fontSize: 20,
              color: '#fff',
            },
          },
          data: [
            {
              name: datas.name,
            },
          ],

          series: [
            {
              // 主圆环
              name: datas.name,
              type: 'pie',
              radius: ['40%', '70%'],
              startAngle: 225,
              color: [
                {
                  type: 'linear',
                  x: 1,
                  y: 0,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(47,172,234,1)', // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: 'rgba(47,172,234,.1)', // 100% 处的颜色
                    },
                  ],
                },
                'transparent',
              ],
              hoverAnimation: true,
              legendHoverLink: false,
              z: 10,
              labelLine: {
                normal: {
                  show: false,
                },
              },
              data: [
                {
                  value: (75 * datas.value) / 100,
                },
                {
                  value: 100 - (75 * datas.value) / 100,
                },
              ],
            },
            {
              // 背景圆环
              name: '',
              type: 'pie',
              radius: ['40%', '70%'],
              silent: true,
              startAngle: 225,
              labelLine: {
                normal: {
                  show: false,
                },
              },
              z: 5,
              data: [
                {
                  value: 75,
                  itemStyle: {
                    color: '#1A3B4C',
                    borderWidth: 2,
                    borderColor: '#1c516b',
                  },
                },
                {
                  value: 25,
                  itemStyle: {
                    color: 'transparent',
                  },
                },
              ],
            },
            {
              // 底部
              name: '',
              type: 'pie',
              radius: ['40%', '70%'],
              startAngle: 230,
              labelLine: {
                show: false,
              },
              z: 15,
              silent: true,
              label: {
                show: true,
                rich: {
                  a: {
                    color: 'transparent',
                    fontSize: 32,
                    padding: [0, -50, -180, 0],
                  },
                  b: {
                    color: 'transparent',
                    fontSize: 32,
                    padding: [0, 0, -180, -50],
                  },
                },
                formatter: function (val) {
                  // 底部0和100
                  if (val.dataIndex === 0) {
                    return '{a|0}';
                  }
                  if (val.dataIndex === 2) {
                    return '{b|100}';
                  }
                },
              },
              data: [
                {
                  // 底部两条线
                  value: 1,
                  itemStyle: {
                    color: '#0096e0',
                  },
                },
                {
                  value: 800,
                  itemStyle: {
                    color: 'transparent',
                  },
                },
                {
                  value: 1,
                  itemStyle: {
                    color: '#0096e0',
                  },
                },
                {
                  value: 230,
                  itemStyle: {
                    color: 'transparent',
                  },
                },
              ],
            },
            {
              // 背景
              name: '',
              type: 'pie',
              cursor: 'default',
              radius: ['0', '80%'],
              hoverAnimation: false,
              legendHoverLink: false,
              itemStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(38,64,76,0.8)', // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: 'rgba(38,64,76,0)', // 100% 处的颜色
                    },
                  ],
                },
              },
              labelLine: {
                normal: {
                  show: false,
                },
              },
              data: [
                {
                  value: 1,
                },
              ],
            },
            {
              // 中间圈
              name: '',
              z: 5,
              type: 'pie',
              cursor: 'default',
              radius: ['32%', '32%'],
              hoverAnimation: false,
              legendHoverLink: false,
              labelLine: {
                normal: {
                  show: false,
                },
              },
              data: [
                {
                  value: 1,
                  itemStyle: {
                    normal: {
                      borderWidth: 2,
                      borderColor: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [
                          {
                            offset: 0,
                            color: 'rgba(2,144,214,0.8)', // 0% 处的颜色
                          },
                          {
                            offset: 1,
                            color: 'rgba(2,144,214,0)', // 100% 处的颜色
                          },
                        ],
                      },
                    },
                  },
                },
              ],
            },
          ],
        }
      )
      window.addEventListener('resize', () => {
        box4.resize()
      })

      let box1 = echarts.init(this.$refs.box1);
      box1.setOption(
        {
          grid: {
            left: '5%',
            right: '5%',
            bottom: '0%',
            top: '5%',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'none'
            },

          },
          xAxis: {
            show: false,
            type: 'value'
          },
          yAxis: [{
            type: 'category',
            inverse: true,
            axisLabel: {
              show: true,
              textStyle: {
                color: '#62D0F9'
              },
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            data: ['1F', '2F', '3F', '4F', '5F', '6F', '7F', '8F']
          }, {
            type: 'category',
            inverse: true,
            axisTick: 'none',
            axisLine: 'none',
            show: true,
            axisLabel: {
              textStyle: {
                color: '#62D0F9',
                fontSize: '12'
              },
              formatter: function (value) {

                return value.toLocaleString() + "kW·h";

              },
            },
            data: [52, 80, 70, 58, 90, 75, 82, 92]
          }],
          series: [{
            name: '能耗',
            type: 'bar',
            zlevel: 1,
            itemStyle: {
              normal: {
                barBorderRadius: 10,
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                  offset: 0,
                  color: 'rgb(57,89,255,1)'
                }, {
                  offset: 1,
                  color: 'rgb(46,200,207,1)'
                }]),
              },
            },
            barWidth: 10,
            data: [52, 80, 70, 58, 90, 75, 82, 92]
          },
          {
            name: '',
            type: 'bar',
            barWidth: 10,
            barGap: '-100%',
            data: [100, 100, 100, 100, 100, 100, 100, 100],
            itemStyle: {
              normal: {
                color: 'rgba(24,31,68,1)',
                barBorderRadius: 20,
              }
            },
          },
          ]
        }
      )
      window.addEventListener('resize', () => {
        box1.resize()
      })
    },
    doEcharts() {
      let box5 = echarts.init(this.$refs.box5);
      box5.setOption(
        {

          tooltip: {
            trigger: 'axis'
          },
          legend: {
            textStyle: {
              color: '#1bb4f6'
            },
            x: 'center',
            y: '20',
            data: ['CO2', 'VOC']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            axisLabel: {
              color: '#ffffff'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#ffffff'
              }
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#ffffff'
              }
            },
            data: this.testArray
          },
          yAxis: {
            max: 1600,
            min: 400,
            type: 'value',
            axisLabel: {
              formatter: '{value}',
              textStyle: {
                color: '#ffffff'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#ffffff'
              }
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#ffffff'
              }
            }
          },
          series: [
            {
              name: 'CO2',
              type: 'line',
              symbol: 'none',
              itemStyle: {
                normal: {
                  color: '#FB7299',
                  lineStyle: {
                    color: "#FB7299",
                    width: 5
                  },
                }
              },
              data: this.yData
            },
            /* {
              name: 'VOC',
              type: 'line',
              symbol: 'none',
              itemStyle: {
                normal: {
                  color: '#5CB2EC',
                  lineStyle: {
                    color: "#5CB2EC",
                    width: 1
                  },
                }
              },
              data: this.y1Data
            } */
          ]
        }
      )
      window.addEventListener('resize', () => {
        box5.resize()
      })

      let box6 = echarts.init(this.$refs.box6);
      box6.setOption({
        grid: {
          left: '5%',
          right: '0%',
          top: '20%',
          bottom: '2%',
          containLabel: true
        },
        tooltip: {
          show: true,
          trigger: 'item'
        },
        legend: {
          show: true,
          x: 'center',
          y: '10',
          icon: 'stack',
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: '#ffffff'
          },
          data: ['温度', '湿度',]
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLabel: {
              color: '#ffffff'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#ffffff'
              }
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#ffffff'
              }
            },
            data: this.testArray
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '值',
            min: 0,
            max: 100,
            axisLabel: {
              formatter: '{value}',
              textStyle: {
                color: '#ffffff'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#ffffff'
              }
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#ffffff'
              }
            }
          },
        ],
        series: [
          {
            name: '温度',
            type: 'line',
            symbol: 'none',
            smooth: true,
            /* symbolSize: 8, */
            itemStyle: {
              normal: {
                color: '#0092f6',
                lineStyle: {
                  color: "#0092f6",
                  width: 5
                },
                /* areaStyle: {
                  //color: '#94C9EC'
                  color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                    offset: 0,
                    color: 'rgba(7,44,90,0.3)'
                  }, {
                    offset: 1,
                    color: 'rgba(0,146,246,0.9)'
                  }]),
                } */
              }
            },
            markPoint: {
              itemStyle: {
                normal: {
                  color: 'red'
                }
              }
            },
            data: this.y1Data
          },
          {
            name: '湿度',
            type: 'line',
            symbol: 'none',
            smooth: true,

            itemStyle: {
              normal: {
                color: '#00d4c7',
                lineStyle: {
                  color: "#00d4c7",
                  width: 5
                },
                /* areaStyle: {
                  //color: '#94C9EC'
                  color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                    offset: 0,
                    color: 'rgba(7,44,90,0.3)'
                  }, {
                    offset: 1,
                    color: 'rgba(0,212,199,0.9)'
                  }]),
                } */
              }
            },
            data: this.y2Data
          },

        ]
      }

      )
      window.addEventListener('resize', () => {
        box6.resize()
      })
    },
    getData() {
      let that = this
      let myDate = new Date();
      this.house = myDate.getHours();
      this.minutes = myDate.getMinutes();
      this.second = myDate.getSeconds();
      let time = this.house + ":" + this.minutes + ":" + this.second
      let jig = {
        "args": ['蜡梅谷气象站温湿度数据接口', '会议室CO2数据接口']
      }
      service.getPublicData(jig).then(rescab => {
        rescab.forEach(item => {
          if (item.name == 'AIR_CO2') {
            that.co2 = item.value
            if (that.testSize > 500) {
              that.testSize = 5000
              that.testArray.shift()
              that.testArray.push(time)
              that.yData.shift()
              that.yData.push(item.value)
            } else {
              this.testArray.splice(that.testSize, 1, time)
              that.yData.push(item.value)
            }
          }
          if (item.name == 'AIR_Temp') {
            if (that.testSize > 500) {
              that.y1Data.shift()
              that.y1Data.push(item.value)
            } else {
              that.y1Data.push(item.value)
            }
          }
          if (item.name == 'AIR_Humd') {
            if (that.testSize > 500) {
              that.y2Data.shift()
              that.y2Data.push(item.value)
            } else {
              that.y2Data.push(item.value)
            }
          }
        })
        that.testSize++
        that.doEcharts()
      }).catch(err => {
        /*  this.$Message.error(err) */
      })
    },
    getEcherData() {
      let obj = {
        "startTime": 1712308464500,
        "stopTime": 1712567664500,
        "id": "651fbe32c5ac3815b5120375",
        "trendLogId": [
          "651fbd52c5ac3815b5120370",
          "651fbdb4c5ac3815b5120372",
          "651fbdecc5ac3815b5120373",
          "651fbe07c5ac3815b5120374"
        ]
      }
      service.trendLogShow(obj).then(res => {
        this.box3.ydata = res[0].times
        this.box3.xdata1 = res[0].val[0].value
        this.box3.xdata2 = res[0].val[1].value
        this.box3.xdata3 = res[0].val[2].value
        this.box3.xdata4 = res[0].val[3].value
        this.echartsPoint()
      }).catch(err => {

      })
    },
  },

  watch: {},
  destroyed() {
    clearInterval(this.timmer)
  },
  beforeDestroy() {
    clearInterval(this.timmer)
  }

}

</script>
<style lang='scss' scoped>
.content_human {
  width: 100%;
  height: 100%;
  background-color: #030006;
  overflow: hidden;
  position: relative;
}

.content_model {
  width: 100%;
  height: 100%;
  background-color: #030006;
  position: absolute;
  z-index: 11;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    color: #fff;
    font-size: 5vh;
  }
}

iframe {
  border: none;
  /* 移除 iframe 的边框 */
  margin: 0;
  /* 移除 iframe 的外边距 */
  padding: 0;
  /* 移除 iframe 的内边距 */
  border-radius: 20px;
  /* 添加圆角边框 */
}



.content_body {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  padding: 20px 20px 0px 20px;
}

.box1 {
  width: 20%;
  height: 30%;
  background-color: transparent;
  position: absolute;
  z-index: 2;
  left: 25px;
  top: 55px;
}

.box_header {
  width: 100%;
  height: 30px;
  /*  background-image: url('../../assets/diy/xiao.png'); */
  background-size: 100% 100%;
  text-align: left;
  line-height: 30px;
  /* padding-left: 50px; */
  color: #ffffff;
  font-size: 1.5vh;
}

.box_body {
  width: 100%;
  height: calc(100% - 30px);
  /* background-image: url('../../assets/diy/03.png'); */
  background-size: 100% 100%;
}

.box2 {
  width: 20%;
  height: 30%;
  background-color: transparent;
  position: absolute;
  z-index: 2;
  left: 25px;
  top: 38%;
}

.box3 {
  width: 20%;
  height: 25%;
  background-color: transparent;
  position: absolute;
  z-index: 2;
  left: 25px;
  top: 70%;
}

.box4 {
  width: 20%;
  height: 30%;
  background-color: transparent;
  position: absolute;
  z-index: 2;
  right: 25px;
  top: 55px;
}

.box5 {
  width: 20%;
  height: 30%;
  background-color: transparent;
  position: absolute;
  z-index: 2;
  right: 25px;
  top: 38%;
}

.box6 {
  width: 20%;
  height: 25%;
  background-color: transparent;
  position: absolute;
  z-index: 2;
  right: 25px;
  top: 70%;
  color: #54d1ff33;
}
</style>


// WEBPACK FOOTER //
// src/components/graphically/trafficSignal.vue